import { AddressFormItem } from './address.interface';
import { AddressFormValues, AddressValues } from './address.schema';
import { AddressTypeEnum } from './adress.enum';

const DEFAULT_COUNTRY = 'Brasil';

const EMPTY_ADDRESS: AddressValues = {
  zipCode: '',
  streetDescription: '',
  streetNumber: '',
  complement: '',
  neighborhood: '',
  city: '',
  state: '',
  country: DEFAULT_COUNTRY,
  code: '',
  municipalityCode: undefined,
  type: AddressTypeEnum.DELIVERY,
};

const removeEmptyEntries = (address: AddressFormItem['address']) =>
  Object.fromEntries(
    Object.entries(address ?? {}).filter(([, value]) => value !== null && value !== undefined),
  );

export const buildAddressFormValues = (item?: AddressFormItem): AddressFormValues => ({
  principal: item?.principal,
  address: { ...EMPTY_ADDRESS, ...removeEmptyEntries(item?.address) } as AddressValues,
});

interface BuildAddressPayloadParams {
  item?: AddressFormItem;
  values: AddressFormValues;
}

export const buildAddressPayload = ({ item, values }: BuildAddressPayloadParams) => ({
  ...item,
  ...values,
  address: { ...item?.address, ...values.address },
});
